/*
 * Decode text using AES
 */
export function aesDecode(encryptText, key) {
  let retVal = null;
  try{
    GibberishAES.size(128);
    retVal = GibberishAES.aesDecrypt(encryptText, key);
  }catch(e){
    console.error(e);    
  }

  return retVal;
}

/*
 * Encode text using AES
 */
export function aesEncode(clearText, key) {
  let retVal = null;
  try{
    GibberishAES.size(128);
    retVal = GibberishAES.aesEncrypt(clearText, key);
  }catch(e){
    console.error(e);    
  }
  
  return retVal;
}

export function replaceStringForCardNumber(cardNumber, data1, memberId) {
  var value = "";
  if (undefined != cardNumber && undefined != data1) {
      var key = memberId + data1.integration;

      try {
        value = aesDecode(cardNumber, key);
      } catch (e) {
        console.error("replaceStringForCardNumber e = " + e);
      }
  }

  return value;
}

export function replaceStringForNtcCardNumberAndExp(number, data1) {
  var value = "";
  if (undefined != number && undefined != data1) {
      var key = data1.integration;
      try {
          value = aesDecode(number, key);
      } catch (e) {
          console.error("replaceStringForCardNumber e = " + e);
      }
  }

  return value;
}

export function replaceStringForBirth(birth, data1, memberId) {
  var value = "";
  if (undefined != birth && undefined != data1) {
      var key = memberId + data1.integration;

      try {
          value = aesDecode(birth, key);
      } catch (e) {
          console.error("replaceStringForBirth e = " + e);
      }
  }

  return value;
}

export function replaceStringForTextIntegration(text, data1, memberId) {
  var value = "";
  if (undefined != text && undefined != data1) {
      var key = memberId + data1.integration;

      try {
          value = aesDecode(text, key);
      } catch (e) {
          console.error("replaceStringForTextIntegration e = " + e);
      }
  }

  return value;
}

export function replaceStringForInquiry(url_pc, data1, memberId) {
  var value = "";
  if (undefined != url_pc && undefined != data1) {
      var key = data1.moomin + memberId;

      try {
          value = aesDecode(url_pc, key);
      } catch (e) {
          console.error("replaceStringForInquiry e = " + e);
      }
  }

  return value;
}

export function replaceStringForAROPCURL(url_pc, data1, memberId) {
  var value = "";
  if (undefined != url_pc && undefined != data1) {
      var key = data1.partialKey + memberId;

      try {
          value = data1.masterUrl + "?k=" + aesDecode(url_pc, key);
      } catch (e) {
          console.error("replaceStringForInquiry e = " + e);
      }
  }

  return value;
}


// WEBPACK FOOTER //
// ./src/utils/cryptoUtil.js